import {
  DEV_MODE,
  HOST_BY_HELP_COM,
  HOST_BY_HELP_IO,
  HOST_BY_HELP_ONLINE,
  HOST_BY_HELP_RU,
  HOST_DEV_BY_HELP_RU,
  HOST_LOCALHOST_3000,
  PROD_MODE,
  UNKNOWN_MODE,
} from '@app/constants';
import type { NUtils } from '@app/types';

export const defineDeployingMode: NUtils.DefineDeployingMode = (clientHost) => {
  const isDevMode =
    clientHost === HOST_LOCALHOST_3000 || clientHost === HOST_DEV_BY_HELP_RU;
  const isProdMode =
    clientHost === HOST_BY_HELP_RU ||
    clientHost === HOST_BY_HELP_IO ||
    clientHost === HOST_BY_HELP_ONLINE ||
    clientHost === HOST_BY_HELP_COM;

  if (isDevMode) {
    return DEV_MODE;
  } else if (isProdMode) {
    return PROD_MODE;
  } else {
    return UNKNOWN_MODE;
  }
};
